import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';

import { StyledDropCont, Link, StyledImg, StyledTitle, StyledToggle, StyledContent, Container } from './styles';

class CertDropdown extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    alt: PropTypes.string,
    desc: PropTypes.node.isRequired,
    disclaimer: PropTypes.string,
    dropDownOpen: PropTypes.bool
  };

  static defaultProps = {
    alt: '',
    disclaimer: undefined,
    dropDownOpen: false
  };




  render() {
    const { title, img, alt, desc, disclaimer, dropDownOpen, onClick } = this.props;

    return (
      <StyledDropCont open={dropDownOpen}>
        <Link onClick={onClick}>
          <Container>
            <StyledImg src={img} alt={alt} />
            <StyledTitle color="grey2" transform="uppercase">
              {title}
            </StyledTitle>
          </Container>

          <StyledToggle>{dropDownOpen ? '' : ''}</StyledToggle>
        </Link>


        <StyledContent open={dropDownOpen}>
          {desc}

          {disclaimer && <Text.Body>*{disclaimer}</Text.Body>}
        </StyledContent>

      </StyledDropCont>
    );
  }
}

export default CertDropdown;
